/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigCreateResponse extends models.ServiceNowCmdbConfigBaseResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigCreateResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigCreateResponse>): ServiceNowCmdbConfigCreateResponse {
        let obj = Object.assign(new ServiceNowCmdbConfigCreateResponse(), model);
        ServiceNowCmdbConfigCreateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigCreateResponse>): ServiceNowCmdbConfigCreateResponse {
        if (!model) return null;
        return ServiceNowCmdbConfigCreateResponse.newInstance(<ServiceNowCmdbConfigCreateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigCreateResponse) {
        if (!obj) return;

        models.ServiceNowCmdbConfigCreateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigCreateResponse): boolean {
        if (models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigCreateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
